module.exports = __webpack_public_path__ + "static/assets/61e99f0da6828d62aa9e3761c15ace9f.svg";